import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DiscoSearchServiceClient } from "clients/DiscoSearchServiceClient";
import { objectSerializationHelper } from "helpers/next-helpers";

const initialState = {
  pdp: {
    membership: {
      availability: {},
      availabilityLoaded: false,
      availabilityError: null,
    },
  },
};

export const fetchAvailability = createAsyncThunk("membership/fetchAvailability", async params => {
  try {
    return DiscoSearchServiceClient.getInstance().membershipAvailabilitySingleProduct(
      objectSerializationHelper(params)
    );
  } catch (e) {
    return Promise.reject(e);
  }
});

export const membershipAvailibilitySlice = createSlice({
  name: "membership",
  initialState,
  extraReducers: builder => {
    builder.addCase(fetchAvailability.fulfilled, (state, action) => {
      if (!state.pdp) state.pdp = {};
      if (!state.pdp.membership) state.pdp.membership = {};
      state.pdp.membership = {
        ...state.pdp.membership,
        availability: action.payload,
        availabilityLoaded: true,
        availabilityError: null,
      };
    });
    builder.addCase(fetchAvailability.rejected, (state, action) => {
      if (!state.pdp) state.pdp = {};
      if (!state.pdp.membership) state.pdp.membership = {};
      state.pdp.membership = {
        ...state.pdp.membership,
        availability: null,
        availabilityLoaded: true,
        availabilityError: action.error?.message,
      };
    });
  },
});

/**
 * This value isn't used anywhere.
 * It's only defined because ReduxApp expects reducers to have a "types" property
 */
export const types = ["membership/fetchAvailability/fulfilled"];

export default {
  types: types,
  fn: membershipAvailibilitySlice.reducer,
};
